module.exports = __webpack_public_path__ + "img/banner-event.622731c8.png";